import { CommonModule } from '@angular/common'
import { Component, CUSTOM_ELEMENTS_SCHEMA, input, output, ViewEncapsulation } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { SimpleQuiz } from '../../models/main/quiz'
import { DdcPrivacyComponent } from '../ddc-privacy/ddc-privacy.component'
import { DdcProfilePicComponent } from '../ddc-profile-pic/ddc-profile-pic.component'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'

@Component({
  selector: 'ddc-quiz-list',
  templateUrl: './ddc-quiz-list.component.html',
  styleUrls: ['./ddc-quiz-list.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    DdcPrivacyComponent,
    DdcProfilePicComponent,
    DdcTextGradientComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DdcQuizListComponent {
  quizzes = input<SimpleQuiz[]>([])
  loading = input<boolean>(false)
  loadingMore = input<boolean>(false)
  hasMore = input<boolean>(true)

  // Events
  onQuizClick = output<{ quizId: number }>()
  onLoadMore = output<void>()

  onQuizCardClick(quizId: number): void {
    this.onQuizClick.emit({ quizId })
  }

  onScrollDown(): void {
    if (!this.loadingMore() && this.hasMore()) {
      this.onLoadMore.emit()
    }
  }
}
